import { render, staticRenderFns } from "./GitHubCallback.vue?vue&type=template&id=0d9287dc&scoped=true&"
import script from "./GitHubCallback.vue?vue&type=script&lang=js&"
export * from "./GitHubCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9287dc",
  null
  
)

export default component.exports